export const LABEL_ENTITY_ASSIGNMENTS_FIELD = 'choice'

export const LABEL_ENTITY_ASSIGNMENTS_CHOICE = {
  keep: 'keep',
  remove: 'remove',
}

export const LABEL_ENTITY_ASSIGNMENTS_INITIAL = {
  [LABEL_ENTITY_ASSIGNMENTS_FIELD]: LABEL_ENTITY_ASSIGNMENTS_CHOICE.keep,
}
